import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';

const SubmitDocs = ({ token, disabled, openDialog }) => (
  <Mutation mutation={NILIFY_TOKEN} onCompleted={openDialog}>
    {nilifyToken => (
      <button
        type="button"
        disabled={disabled}
        className={`alert-button${disabled ? ' disabled' : ''}`}
        onClick={() =>
          nilifyToken({
            variables: { token },
          })
        }>
        SUBMIT DOCUMENTS
      </button>
    )}
  </Mutation>
);

const NILIFY_TOKEN = gql`
  mutation nilifyToken($token: String!) {
    nilifyToken(token: $token) {
      success
      errors {
        message
      }
    }
  }
`;

export default SubmitDocs;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/SubmitDocs.js